import { render, staticRenderFns } from "./appointmentTh.vue?vue&type=template&id=53de617e&scoped=true&"
import script from "./appointmentTh.vue?vue&type=script&lang=js&"
export * from "./appointmentTh.vue?vue&type=script&lang=js&"
import style0 from "./appointmentTh.vue?vue&type=style&index=0&id=53de617e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de617e",
  null
  
)

export default component.exports